import {
	GET_STATES_LIST,
	GET_STATES_LIST_SUCCESS,
	GET_STATES_LIST_FAIL,
	GET_STATES_LIST_RESET,
} from '../actions/getStatesListAction';

const initialState = {
	apiState: '',
	message: '',
	data: null,
	error: '',
};

const getStatesListReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_STATES_LIST:
			return {
				...state,
				apiState: 'loading',
			};
		case GET_STATES_LIST_SUCCESS:
			return {
				...state,
				apiState: 'success',
				data: action.response.data,
				message: action.response.message
					? action.response.message
					: 'success',
			};
		case GET_STATES_LIST_FAIL:
			return {
				...state,
				apiState: 'error',
				error: action.response.errors,
				message: action.response.message
					? action.response.message
					: 'error',
			};
		case GET_STATES_LIST_RESET:
			return initialState;
		default:
			return state;
	}
};

export default getStatesListReducer;
